/**
 * TODO: Re-factor this code using function calling without setting global
 * parameters
 */
var lotteryFeedFlg = false;
var lotteryFeedAppendData;
var bonusFeedFlg = false;
var bonusFeedAppendData;
var localFranchiseId = -1;
var localBonusIdList = -1;
var MAX_SHOP_BONUS_FEED = 20;
$(document).ready(function() {
	var numObjMax = 3;
	var objLotteryFeed = $("#lottery-feed");
	var tableRowHeight = 61;
	var listNum = $("tr", objLotteryFeed).length;
	var listActive = 1;
	var totalHeight = numObjMax * tableRowHeight;

	if (listNum <= numObjMax) {
		totalHeight = listNum * tableRowHeight;
	}

	var tableHeight = listNum * tableRowHeight;
	var tableStartPos = tableHeight - totalHeight;

	$("table", objLotteryFeed).css("margin-top", "-" + tableStartPos + "px");
	$(".overflow-container", objLotteryFeed).css("height", totalHeight);

	var indexLottery = 0 - tableStartPos;
	function adjust() {
		var firstRow = $("#playerLotteryFeed").find('tr').eq(0);
		if (lotteryFeedFlg) {
			if (firstRow.attr('id') === 'empty' && $($(lotteryFeedAppendData).get(0)).attr('id') !== 'empty') {
				firstRow.remove();
			}
			$.each($(lotteryFeedAppendData), function(index, element) {
				if (!existsInTable("playerLotteryFeed", $(element).attr('id'))) {
					$("table", objLotteryFeed).append(element);
				}
			});

			listNum = $("tr", objLotteryFeed).length;
			if (listNum <= numObjMax) {
				totalHeight = listNum * tableRowHeight;
			}
			tableHeight = listNum * tableRowHeight;
			tableStartPos = tableHeight - totalHeight;
			setTimeout("getLotteryFeed(" + localFranchiseId + ")", 21000);
			lotteryFeedFlg = false;
		}

		if (listNum > numObjMax) {
			$("table", objLotteryFeed).prepend($("table tr:nth-child(" + listNum + ")", objLotteryFeed));
		}

		$("table", objLotteryFeed).css("margin-top", "-" + tableStartPos + "px");
		$(".overflow-container", objLotteryFeed).css("height", totalHeight);
		indexLottery = 0 - tableStartPos;
		listActive = 1;

		timeout = setTimeout(function() {
			animate();
		}, 3000);
	}

	function animate() {
		if (listNum > numObjMax) {
			$("table", objLotteryFeed).animate({
				marginTop : indexLottery + listActive * tableRowHeight
			}, {
				queue : false,
				duration : 500,
				complete : adjust
			});
		} else {
			adjust();
		}
	}

	var timeout;
	timeout = setTimeout(function() {
		animate();
	}, 3000);

	var numObjMaxBonus = 3;
	var objBonusFeed = $('#bonus-feed');
	var bonusListNum = $('tr', objBonusFeed).length;
	var bonusListActive = 1;
	var bonusTotalHeight = numObjMaxBonus * tableRowHeight;

	if (bonusListNum < numObjMaxBonus) {
		bonusTotalHeight = bonusListNum * tableRowHeight;
	}

	var bonusTableHeight = bonusListNum * tableRowHeight;
	var bonusTableStartPos = bonusTableHeight - bonusTotalHeight;

	$("table", objBonusFeed).css("margin-top", "-" + bonusTableStartPos + "px");
	$(".overflow-container", objBonusFeed).css("height", bonusTotalHeight);

	var indexBonus = 0 - bonusTableStartPos;
	function bonusAdjust() {

		var firstRow = $("#playerShopBonusFeed").find('tr').eq(0);
		if (bonusFeedFlg) {
			if (firstRow.attr('id') === 'empty' && $($(bonusFeedAppendData).get(0)).attr('id') !== 'empty') {
				firstRow.remove();
			}
			$.each($(bonusFeedAppendData), function(index, element) {
				if (!existsInTable("playerShopBonusFeed", $(element).attr('id'))) {
					// if more than 20 record delete top one
					if ($("tr", objBonusFeed).length > MAX_SHOP_BONUS_FEED)
						$("table", objBonusFeed).find("tr:first").remove();
					$("table", objBonusFeed).append(element);
				}
			});

			bonusListNum = $("tr", objBonusFeed).length;

			if (bonusListNum <= numObjMaxBonus) {
				bonusTotalHeight = bonusListNum * tableRowHeight;
			}
			bonusTableHeight = bonusListNum * tableRowHeight;
			bonusTableStartPos = bonusTableHeight - bonusTotalHeight;
			setTimeout("getShopBonusFeed(" + localBonusIdList + ")", 21000);
			bonusFeedFlg = false;
		}

		if (bonusListNum > numObjMaxBonus) {
			$("table", objBonusFeed).prepend($("table tr:nth-child(" + bonusListNum + ")", objBonusFeed));
		}

		$("table", objBonusFeed).css("margin-top", "-" + bonusTableStartPos + "px");
		$(".overflow-container", objBonusFeed).css("height", bonusTotalHeight);
		indexBonus = 0 - bonusTableStartPos;
		bonusListActive = 1;

		timeout = setTimeout(function() {
			bonusAnimate();
		}, 3000);
	}

	function bonusAnimate() {
		if (bonusListNum > numObjMaxBonus) {
			$("table", objBonusFeed).animate({
				marginTop : indexBonus + bonusListActive * tableRowHeight
			}, {
				queue : false,
				duration : 500,
				complete : bonusAdjust
			});
		} else
			bonusAdjust();
	}

	var btimeout;
	btimeout = setTimeout(function() {
		bonusAnimate();
	}, 3000);
});

/**
 * Players who purchased tickets for lotteries shown as feed.
 */
var lotteryFeedJSON = {
	success : function(o) {
		var params = YAHOO.lang.JSON.parse(o.responseText);
		lotteryFeedAppendData = params.PLAYER_LOTTERY_FEED_LIST;
		lotteryFeedFlg = true;
	},
	failure : function(o) {
	},
	cache : false,
	timeout : 5000
}

/**
 * Returns most recent players who bought lottery ticket for visible lottery.
 */
function getLotteryFeed(franchiseId) {
	if (localFranchiseId === -1) {
		localFranchiseId = franchiseId;
	}
	YAHOO.util.Connect.asyncRequest('POST', domainUrl, lotteryFeedJSON, 'flow=getPlayerLotteryFeed' + '&fid='
			+ localFranchiseId);
}

/**
 * Players who purchased shop bonus shown as feed. Set local id on first call.
 */
var shopBonusFeedJSON = {
	success : function(o) {
		var params = YAHOO.lang.JSON.parse(o.responseText);
		bonusFeedAppendData = params.PLAYER_SHOP_BONUS_FEED_LIST;
		bonusFeedFlg = true;
	},
	failure : function(o) {
	},
	cache : false,
	timeout : 5000
};

/**
 * Returns most recent players who bought shop bonus. Set local id on first call.
 */
function getShopBonusFeed(bonusIdList) {
	if (localBonusIdList === -1) {
		localBonusIdList = bonusIdList;
	}
	YAHOO.util.Connect.asyncRequest('POST', domainUrl, shopBonusFeedJSON, 'flow=GetPlayerShopBonusFeed' + '&bonusIdList=' + localBonusIdList);
}

/**
 * Check if an element exists in the table
 * 
 * @param arrayId
 * @param rowId
 * @returns {Boolean}
 */
function existsInTable(arrayId, rowId) {
	var returnValue = false;
	$('#' + arrayId).find('tr').each(function() {
		if ($(this).attr('id') === rowId) {
			returnValue = true;
		}
	});
	return returnValue;
}
;
define("legacy/mypages/feedAnimation", function(){});

